import Constants from "../utils/consts";
import Utils from "../utils/utils";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function getPresenzeCorso(uname, token, corsoId) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "getPresenzeCorso.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);

        try {
          const bodyString = body.toString();
          console.log(
            "[getPresenzeCorso] Raw response (first 1000 chars):",
            bodyString.substring(0, 1000)
          );

          let resp;
          try {
            // Prova prima il parsing diretto (il backend dovrebbe restituire JSON già valido)
            resp = JSON.parse(bodyString);
            console.log(
              "[getPresenzeCorso] JSON parsato con successo (parsing diretto)"
            );
          } catch (directParseError) {
            console.log(
              "[getPresenzeCorso] Parsing diretto fallito, provo con unescapeString"
            );
            // Se fallisce, prova con unescapeString (per retrocompatibilità)
            const unescapedString = Utils.unescapeString(bodyString);
            console.log(
              "[getPresenzeCorso] Unescaped response (first 1000 chars):",
              unescapedString.substring(0, 1000)
            );
            resp = JSON.parse(unescapedString);
            console.log(
              "[getPresenzeCorso] JSON parsato con successo (con unescapeString)"
            );
          }

          console.log(
            "[getPresenzeCorso] Risposta backend (sample):",
            resp.slice(0, 3)
          );
          resolve(resp);
        } catch (error) {
          console.error("[getPresenzeCorso] Errore nel parsing JSON:", error);
          console.error("[getPresenzeCorso] Response body:", body.toString());
          reject(
            new Error(`Errore nel parsing della risposta: ${error.message}`)
          );
        }
      });

      res.on("error", function(error) {
        console.error(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
      corsoId: corsoId,
    });

    req.write(postData);

    req.end();
  });
}
